import React, { useEffect, useMemo, useState, createElement } from 'react';
import { Receipt, Upload, Search, Download, ArrowLeft, ChevronRight, CheckCircle2, Clock, AlertCircle, Loader2, FileText, X, TrendingDown, TrendingUp, Send, MapPin, Truck } from 'lucide-react';
import { KpiCard } from '../KpiCard';
import { ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
type InvoiceStatus = 'In analisi' | 'Analizzata' | 'Errore';
type ContestedRow = {
  anno_sped: number;
  numero_sped: number;
  data_ritiro: string;
  numero_colli: number;
  peso_bollettato_kg: number;
  porto: number;
  totale_servizi: number;
  porto_contestabile: number;
  servizi_contestabili: number;
  ragione_sociale_destinat: string;
  indirizzo_destinatario: string;
  cap_destinatario: string;
  localita_destinatario: string;
  provincia_destinatario: string;
  ragione_sociale_mittente: string;
  natura_merce: string;
  imponibile_iva: number;
};
type Invoice = {
  id: string;
  fileName: string;
  carrier: string;
  numeroFattura: number;
  dataFattura: string;
  uploadedAt: string;
  status: InvoiceStatus;
  righeTotali: number;
  righeContestate: number;
  totalePagato: number;
  totalePortoContestabile: number;
  totaleServiziContestabili: number;
  totaleContestato: number;
  rows: ContestedRow[];
  creditRequested?: boolean;
};
const SAMPLE_ROWS: ContestedRow[] = [{
  anno_sped: 2025,
  numero_sped: 2036443,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'MAMELI LUCIA',
  indirizzo_destinatario: 'VIA MONSIGNORE VIRGILIO,13/A',
  cap_destinatario: '09134',
  localita_destinatario: 'CAGLIARI',
  provincia_destinatario: 'CA',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036447,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'MILANI FLAVIANA',
  indirizzo_destinatario: 'VIA SAN MARCELLINO,8',
  cap_destinatario: '07026',
  localita_destinatario: 'OLBIA',
  provincia_destinatario: 'SS',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036452,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'ANTONINO CAMINITO',
  indirizzo_destinatario: 'CONTRADA RANDAZZA,SNC',
  cap_destinatario: '96010',
  localita_destinatario: 'MELILLI',
  provincia_destinatario: 'SR',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036456,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'GIGLIO SALVATORE',
  indirizzo_destinatario: 'VIA LUIGI EINAUDI,48',
  cap_destinatario: '90146',
  localita_destinatario: 'PALERMO',
  provincia_destinatario: 'PA',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036494,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'SCALIA FRANCESCO PANIFICIO DELIZIE',
  indirizzo_destinatario: 'VIA ANTONELLO GAGINI,9',
  cap_destinatario: '90019',
  localita_destinatario: 'TRABIA',
  provincia_destinatario: 'PA',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036501,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'MARIA CIPITI',
  indirizzo_destinatario: 'VIA CELSO,5',
  cap_destinatario: '98070',
  localita_destinatario: 'MILITELLO ROSMARINO',
  provincia_destinatario: 'ME',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036626,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'MARGHERITA PAPPALARDO',
  indirizzo_destinatario: 'VIA MAZZAGLIA,45/B',
  cap_destinatario: '95030',
  localita_destinatario: 'RAGALNA',
  provincia_destinatario: 'CT',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036657,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'RAO DOMENICA',
  indirizzo_destinatario: 'VIA COMUNALE ACQUITTA,102/A',
  cap_destinatario: '98050',
  localita_destinatario: 'VIGLIATORE',
  provincia_destinatario: 'ME',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036680,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'RAFFAELA MACIS',
  indirizzo_destinatario: 'VIA INGURTOSU,11',
  cap_destinatario: '09121',
  localita_destinatario: 'CAGLIARI',
  provincia_destinatario: 'CA',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}, {
  anno_sped: 2025,
  numero_sped: 2036683,
  data_ritiro: '2025-09-01',
  numero_colli: 1,
  peso_bollettato_kg: 1.0,
  porto: 4.5,
  totale_servizi: 1.974,
  porto_contestabile: 0.225,
  servizi_contestabili: 0.2961,
  ragione_sociale_destinat: 'GHIANI PIERA',
  indirizzo_destinatario: "VIA D'ANNUNZIO,14",
  cap_destinatario: '09040',
  localita_destinatario: 'VILLAPUTZU',
  provincia_destinatario: 'SU',
  ragione_sociale_mittente: 'FLOW S.R.L.',
  natura_merce: 'VARIE',
  imponibile_iva: 6.47
}];
const INITIAL_INVOICES: Invoice[] = [{
  id: 'INV-2025-001',
  fileName: 'Fattura_BRT_592998_set2025.pdf',
  carrier: 'BRT',
  numeroFattura: 592998,
  dataFattura: '2025-09-30',
  uploadedAt: '24 mag · 09:12',
  status: 'Analizzata',
  righeTotali: 27650,
  righeContestate: 2162,
  totalePagato: 178910.45,
  totalePortoContestabile: 489.5,
  totaleServiziContestabili: 646.41,
  totaleContestato: 1135.91,
  rows: SAMPLE_ROWS
}, {
  id: 'INV-2025-002',
  fileName: 'Fattura_GLS_44210_ago2025.pdf',
  carrier: 'GLS',
  numeroFattura: 44210,
  dataFattura: '2025-08-31',
  uploadedAt: '15 mag · 14:30',
  status: 'Analizzata',
  righeTotali: 18420,
  righeContestate: 932,
  totalePagato: 96420.0,
  totalePortoContestabile: 218.2,
  totaleServiziContestabili: 312.4,
  totaleContestato: 530.6,
  rows: SAMPLE_ROWS.slice(0, 5),
  creditRequested: true
}, {
  id: 'INV-2025-003',
  fileName: 'Fattura_FedEx_FE990887_lug2025.pdf',
  carrier: 'FedEx',
  numeroFattura: 990887,
  dataFattura: '2025-07-31',
  uploadedAt: '06 mag · 16:48',
  status: 'Analizzata',
  righeTotali: 8920,
  righeContestate: 312,
  totalePagato: 142800.0,
  totalePortoContestabile: 88.4,
  totaleServiziContestabili: 124.8,
  totaleContestato: 213.2,
  rows: SAMPLE_ROWS.slice(0, 3)
}];
export function VerificaFatture() {
  const [invoices, setInvoices] = useState<Invoice[]>(INITIAL_INVOICES);
  const [query, setQuery] = useState('');
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [toast, setToast] = useState<string | null>(null);
  const filtered = useMemo(() => invoices.filter(i => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return `${i.id} ${i.fileName} ${i.carrier} ${i.numeroFattura}`.toLowerCase().includes(q);
  }), [invoices, query]);
  const totFatture = invoices.length;
  const totContestato = invoices.reduce((acc, i) => acc + i.totaleContestato, 0);
  const totPagato = invoices.reduce((acc, i) => acc + i.totalePagato, 0);
  const percentExtra = totPagato > 0 ? totContestato / totPagato * 100 : 0;
  const totRecuperato = invoices.filter(i => i.creditRequested).reduce((acc, i) => acc + i.totaleContestato, 0);
  const totDaRecuperare = totContestato - totRecuperato;
  const percentRecuperato = totContestato > 0 ? totRecuperato / totContestato * 100 : 0;
  const recoveryData = [{
    name: 'Recuperato',
    value: totRecuperato,
    color: '#D4FF3A'
  }, {
    name: 'Da recuperare',
    value: totDaRecuperare,
    color: '#3F3F3F'
  }];
  const MONTH_LABELS = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
  const timelineData = useMemo(() => {
    // Build a 6-month rolling window ending at the latest invoice month
    const dates = invoices.map(i => new Date(i.dataFattura));
    const maxDate = dates.length ? new Date(Math.max(...dates.map(d => d.getTime()))) : new Date();
    const buckets: {
      key: string;
      label: string;
      extra: number;
    }[] = [];
    for (let offset = 5; offset >= 0; offset--) {
      const d = new Date(maxDate.getFullYear(), maxDate.getMonth() - offset, 1);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      buckets.push({
        key,
        label: `${MONTH_LABELS[d.getMonth()]} ${String(d.getFullYear()).slice(2)}`,
        extra: 0
      });
    }
    invoices.forEach(i => {
      const d = new Date(i.dataFattura);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      const bucket = buckets.find(b => b.key === key);
      if (bucket) bucket.extra += i.totaleContestato;
    });
    return buckets;
  }, [invoices]);
  const addInvoice = (file: File, carrier: string) => {
    const id = `INV-${Date.now()}`;
    const now = new Date();
    const ts = `${now.getDate()} ${['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'][now.getMonth()]} · ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    const newInvoice: Invoice = {
      id,
      fileName: file.name,
      carrier,
      numeroFattura: Math.floor(Math.random() * 900000) + 100000,
      dataFattura: now.toISOString().slice(0, 10),
      uploadedAt: ts,
      status: 'In analisi',
      righeTotali: 0,
      righeContestate: 0,
      totalePagato: 0,
      totalePortoContestabile: 0,
      totaleServiziContestabili: 0,
      totaleContestato: 0,
      rows: []
    };
    setInvoices(prev => [newInvoice, ...prev]);
    setUploadOpen(false);
    // Simulate analysis after 3.5s
    setTimeout(() => {
      const righeTotali = Math.floor(Math.random() * 25000) + 5000;
      const righeContestate = Math.floor(righeTotali * (Math.random() * 0.08 + 0.02));
      const totalePagato = Math.round(righeTotali * (Math.random() * 4 + 4) * 100) / 100;
      const totalePortoContestabile = Math.round(righeContestate * 0.22 * 100) / 100;
      const totaleServiziContestabili = Math.round(righeContestate * 0.29 * 100) / 100;
      const totaleContestato = totalePortoContestabile + totaleServiziContestabili;
      setInvoices(prev => prev.map(i => i.id === id ? {
        ...i,
        status: 'Analizzata',
        righeTotali,
        righeContestate,
        totalePagato,
        totalePortoContestabile,
        totaleServiziContestabili,
        totaleContestato,
        rows: SAMPLE_ROWS
      } : i));
      setToast(`Analisi completata: ${righeContestate.toLocaleString('it-IT')} righe contestate, € ${totaleContestato.toFixed(2)} di extra costi.`);
      setTimeout(() => setToast(null), 5000);
    }, 3500);
  };
  const requestCredit = (invoiceId: string) => {
    setInvoices(prev => prev.map(i => i.id === invoiceId ? {
      ...i,
      creditRequested: true
    } : i));
    setToast(`Richiesta di credito inviata al corriere.`);
    setTimeout(() => setToast(null), 4000);
  };
  const selected = selectedId ? invoices.find(i => i.id === selectedId) ?? null : null;
  if (selected) {
    return <VerificaFattureDetail invoice={selected} onBack={() => setSelectedId(null)} onRequestCredit={() => requestCredit(selected.id)} toast={toast} data-id="element-3575" />;
  }
  return <div className="space-y-6" data-id="element-3576">
      <div className="flex items-end justify-between flex-wrap gap-3" data-id="element-3577">
        <div data-id="element-3578">
          <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-3579">
            Verifica Fatture
          </h1>
        </div>
        <button type="button" onClick={() => setUploadOpen(true)} className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-3580">
          <Upload className="h-4 w-4" data-id="element-3581" />
          Carica fattura
        </button>
      </div>

      <section className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-3582">
        {/* Recovery donut */}
        <div className="bg-[#181818] border border-[#262626] rounded-xl p-5 flex flex-col" data-id="element-3583">
          <div className="flex items-center justify-between mb-1" data-id="element-3584">
            <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-3585">
              Recuperato sul totale
            </h3>
            <span className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3586">
              {percentRecuperato.toFixed(0)}%
            </span>
          </div>
          <p className="text-xs text-[#9A9A9A] mb-3" data-id="element-3587">
            Crediti richiesti vs extra ancora aperti.
          </p>
          <div className="flex-1 flex items-center gap-5" data-id="element-3588">
            <div className="relative h-[150px] w-[150px] shrink-0" data-id="element-3589">
              <ResponsiveContainer width="100%" height="100%" data-id="element-3590">
                <PieChart data-id="element-3591">
                  <Pie data={recoveryData} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70} paddingAngle={2} stroke="none" isAnimationActive={false} data-id="element-3592">
                    {recoveryData.map(d => <Cell key={d.name} fill={d.color} data-id="element-3593" />)}
                  </Pie>
                  <Tooltip cursor={false} contentStyle={{
                  background: '#0A0A0A',
                  border: '1px solid #262626',
                  borderRadius: 8,
                  fontSize: 12,
                  color: '#FAFAFA'
                }} formatter={(value: number) => `€ ${value.toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}`} data-id="element-3594" />
                </PieChart>
              </ResponsiveContainer>
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-3595">
                <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3596">
                  Recuperato
                </div>
                <div className="text-base font-semibold text-[#FAFAFA] font-mono" data-id="element-3597">
                  €{' '}
                  {totRecuperato.toLocaleString('it-IT', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
                </div>
              </div>
            </div>
            <div className="flex-1 min-w-0 space-y-2.5" data-id="element-3598">
              <LegendRow color="#D4FF3A" label="Recuperato" value={totRecuperato} data-id="element-3599" />
              <LegendRow color="#3F3F3F" label="Da recuperare" value={totDaRecuperare} data-id="element-3600" />
              <div className="border-t border-[#1F1F1F] pt-2.5" data-id="element-3601">
                <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3602">
                  Extra totali
                </div>
                <div className="text-sm font-mono font-semibold text-[#FAFAFA] mt-0.5" data-id="element-3603">
                  €{' '}
                  {totContestato.toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Extra over time */}
        <div className="bg-[#181818] border border-[#262626] rounded-xl p-5 flex flex-col lg:col-span-2" data-id="element-3604">
          <div className="flex items-start justify-between mb-1 gap-3 flex-wrap" data-id="element-3605">
            <div data-id="element-3606">
              <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-3607">
                Extra fatturati nel tempo
              </h3>
              <p className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3608">
                Distribuzione degli extra costi negli ultimi 6 mesi.
              </p>
            </div>
            <div className="flex items-center gap-4 text-xs" data-id="element-3609">
              <div data-id="element-3610">
                <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3611">
                  Totale periodo
                </div>
                <div className="font-mono font-semibold text-[#FAFAFA]" data-id="element-3612">
                  €{' '}
                  {totContestato.toLocaleString('it-IT', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
                </div>
              </div>
              <div data-id="element-3613">
                <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3614">
                  % sul pagato
                </div>
                <div className="font-mono font-semibold text-[#FAFAFA]" data-id="element-3615">
                  {percentExtra.toFixed(2)}%
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 mt-3 min-h-[170px]" data-id="element-3616">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3617">
              <LineChart data={timelineData} margin={{
              top: 10,
              right: 8,
              left: -12,
              bottom: 0
            }} data-id="element-3618">
                <defs data-id="element-3619">
                  <linearGradient id="extraGrad" x1="0" y1="0" x2="0" y2="1" data-id="element-3620">
                    <stop offset="0%" stopColor="#D4FF3A" stopOpacity={0.25} data-id="element-3621" />
                    <stop offset="100%" stopColor="#D4FF3A" stopOpacity={0} data-id="element-3622" />
                  </linearGradient>
                </defs>
                <CartesianGrid vertical={false} stroke="#1F1F1F" strokeDasharray="3 3" data-id="element-3623" />
                <XAxis dataKey="label" tick={{
                fill: '#6B6B6B',
                fontSize: 11
              }} axisLine={false} tickLine={false} data-id="element-3624" />
                <YAxis tick={{
                fill: '#6B6B6B',
                fontSize: 11
              }} axisLine={false} tickLine={false} tickFormatter={v => `€${Math.round(v / 1).toLocaleString('it-IT')}`} width={56} data-id="element-3625" />
                <Tooltip cursor={{
                stroke: '#D4FF3A',
                strokeWidth: 1,
                strokeDasharray: '3 3'
              }} contentStyle={{
                background: '#0A0A0A',
                border: '1px solid #262626',
                borderRadius: 8,
                fontSize: 12,
                color: '#FAFAFA'
              }} labelStyle={{
                color: '#9A9A9A'
              }} formatter={(value: number) => [`€ ${value.toLocaleString('it-IT', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`, 'Extra']} data-id="element-3626" />
                <Line type="monotone" dataKey="extra" stroke="#D4FF3A" strokeWidth={2} dot={{
                fill: '#0A0A0A',
                stroke: '#D4FF3A',
                strokeWidth: 2,
                r: 3
              }} activeDot={{
                r: 5,
                fill: '#D4FF3A',
                stroke: '#0A0A0A',
                strokeWidth: 2
              }} fill="url(#extraGrad)" data-id="element-3627" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </section>

      {toast && <div className="flex items-start gap-2 p-3 bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 rounded-lg" data-id="element-3628">
          <CheckCircle2 className="h-4 w-4 text-[#D4FF3A] shrink-0 mt-0.5" data-id="element-3629" />
          <p className="text-sm text-[#FAFAFA]" data-id="element-3630">{toast}</p>
        </div>}

      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3631">
        <div className="p-4 sm:p-5 flex items-center gap-3 flex-wrap border-b border-[#1F1F1F]" data-id="element-3632">
          <div className="flex items-center gap-2" data-id="element-3633">
            <Receipt className="h-4 w-4 text-[#9A9A9A]" data-id="element-3634" />
            <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-3635">
              Fatture analizzate
            </h3>
          </div>
          <div className="relative ml-auto w-full sm:w-auto" data-id="element-3636">
            <Search className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-3637" />
            <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Cerca per nome file, corriere, n. fattura..." className="w-full sm:w-80 pl-9 pr-3 py-2 bg-[#0A0A0A] border border-[#262626] rounded-lg text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-3638" />
          </div>
        </div>

        {filtered.length === 0 ? <div className="p-12 text-center" data-id="element-3639">
            <Receipt className="h-8 w-8 text-[#6B6B6B] mx-auto mb-3" data-id="element-3640" />
            <p className="text-sm text-[#9A9A9A]" data-id="element-3641">Nessuna fattura trovata.</p>
          </div> : <div className="overflow-x-auto" data-id="element-3642">
            <table className="w-full text-sm [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap" data-id="element-3643">
              <thead data-id="element-3644">
                <tr className="text-left text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#1F1F1F]" data-id="element-3645">
                  <th className="px-5 py-3 font-medium" data-id="element-3646">N. fattura</th>
                  <th className="px-5 py-3 font-medium" data-id="element-3647">Corriere</th>
                  <th className="px-5 py-3 font-medium" data-id="element-3648">Data fattura</th>
                  <th className="px-5 py-3 font-medium text-right" data-id="element-3649">Pagato</th>
                  <th className="px-5 py-3 font-medium text-right" data-id="element-3650">
                    Extra costo
                  </th>
                  <th className="px-5 py-3 font-medium" data-id="element-3651">Split pagato/extra</th>
                  <th className="px-5 py-3 font-medium" data-id="element-3652">Stato</th>
                  <th className="px-5 py-3 font-medium w-8" data-id="element-3653" />
                </tr>
              </thead>
              <tbody data-id="element-3654">
                {filtered.map(inv => {
              const isAnalyzed = inv.status === 'Analizzata';
              const isAnalyzing = inv.status === 'In analisi';
              const extraPct = inv.totalePagato > 0 ? inv.totaleContestato / inv.totalePagato * 100 : 0;
              return <tr key={inv.id} onClick={() => isAnalyzed && setSelectedId(inv.id)} className={`border-b border-[#1F1F1F] last:border-0 transition-colors ${isAnalyzed ? 'hover:bg-[#0A0A0A] cursor-pointer' : ''}`} data-id="element-3655">
                      <td className="px-5 py-3.5" data-id="element-3656">
                        <div className="text-sm font-mono text-[#FAFAFA]" data-id="element-3657">
                          {inv.numeroFattura}
                        </div>
                        <div className="text-[11px] text-[#6B6B6B] truncate max-w-[220px]" data-id="element-3658">
                          {inv.fileName}
                        </div>
                      </td>
                      <td className="px-5 py-3.5 text-sm text-[#FAFAFA]" data-id="element-3659">
                        {inv.carrier}
                      </td>
                      <td className="px-5 py-3.5 text-xs font-mono text-[#9A9A9A]" data-id="element-3660">
                        {inv.dataFattura}
                      </td>
                      <td className="px-5 py-3.5 text-right font-mono text-sm text-[#FAFAFA]" data-id="element-3661">
                        {isAnalyzed ? `€ ${inv.totalePagato.toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}` : '—'}
                      </td>
                      <td className="px-5 py-3.5 text-right" data-id="element-3662">
                        {isAnalyzed ? <span className="font-mono text-sm font-semibold text-[#FAFAFA]" data-id="element-3663">
                            €{' '}
                            {inv.totaleContestato.toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                          </span> : <span className="text-xs text-[#6B6B6B]" data-id="element-3664">—</span>}
                      </td>
                      <td className="px-5 py-3.5" data-id="element-3665">
                        {isAnalyzed ? <SplitBar pct={extraPct} data-id="element-3666" /> : <span className="text-xs text-[#6B6B6B]" data-id="element-3667">—</span>}
                      </td>
                      <td className="px-5 py-3.5" data-id="element-3668">
                        <StatusBadge status={inv.status} data-id="element-3669" />
                        {inv.creditRequested && isAnalyzed && <div className="text-[10px] text-[#D4FF3A] mt-1" data-id="element-3670">
                            Credito richiesto
                          </div>}
                      </td>
                      <td className="px-5 py-3.5 text-right" data-id="element-3671">
                        {isAnalyzed && <ChevronRight className="h-4 w-4 text-[#6B6B6B] inline" data-id="element-3672" />}
                      </td>
                    </tr>;
            })}
              </tbody>
            </table>
          </div>}
      </div>

      {uploadOpen && <UploadInvoiceModal onCancel={() => setUploadOpen(false)} onSubmit={addInvoice} data-id="element-3673" />}
    </div>;
}
function LegendRow({
  color,
  label,
  value
}: {
  color: string;
  label: string;
  value: number;
}) {
  return <div className="flex items-center justify-between gap-3" data-id="element-3674">
      <div className="flex items-center gap-2 min-w-0" data-id="element-3675">
        <span className="h-2.5 w-2.5 rounded-sm shrink-0" style={{
        backgroundColor: color
      }} data-id="element-3676" />
        <span className="text-xs text-[#9A9A9A] truncate" data-id="element-3677">{label}</span>
      </div>
      <span className="font-mono text-xs text-[#FAFAFA] shrink-0" data-id="element-3678">
        €{' '}
        {value.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}
      </span>
    </div>;
}
function StatusBadge({
  status
}: {
  status: InvoiceStatus;
}) {
  // Subtle inline status indicator (dot + label), not a button-looking chip.
  const cfg = {
    'In analisi': {
      text: 'text-[#5DA9FF]',
      dot: 'bg-[#5DA9FF]',
      spin: true
    },
    Analizzata: {
      text: 'text-[#9A9A9A]',
      dot: 'bg-[#D4FF3A]',
      spin: false
    },
    Errore: {
      text: 'text-[#EF4444]',
      dot: 'bg-[#EF4444]',
      spin: false
    }
  }[status];
  return <span className={`inline-flex items-center gap-1.5 text-xs ${cfg.text}`} data-id="element-3679">
      {cfg.spin ? <Loader2 className="h-3 w-3 animate-spin" data-id="element-3680" /> : <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} data-id="element-3681" />}
      <span className="font-medium" data-id="element-3682">{status}</span>
    </span>;
}
function SplitBar({
  pct
}: {
  pct: number;
}) {
  // Single progress bar: dark grey track, red fill showing the share of
  // the invoice that is contestable as credit.
  const safePct = Math.min(Math.max(pct, 0), 100);
  return <div className="w-32" data-id="element-3683">
      <div className="h-1.5 rounded-full bg-[#1F1F1F] overflow-hidden" data-id="element-3684">
        <div className="h-full bg-[#EF4444] transition-[width] duration-300" style={{
        width: `${Math.max(safePct, 0.1)}%`
      }} data-id="element-3685" />
      </div>
      <div className="text-[10px] font-mono text-[#6B6B6B] mt-1" data-id="element-3686">
        <span className="text-[#EF4444]" data-id="element-3687">{pct.toFixed(2)}%</span> contestabile
      </div>
    </div>;
}
function UploadInvoiceModal({
  onCancel,
  onSubmit
}: {
  onCancel: () => void;
  onSubmit: (file: File, carrier: string) => void;
}) {
  const [file, setFile] = useState<File | null>(null);
  const [carrier, setCarrier] = useState('BRT');
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-3688">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onCancel} data-id="element-3689" />
      <div className="relative w-full max-w-lg bg-[#0A0A0A] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3690">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-[#262626]" data-id="element-3691">
          <div data-id="element-3692">
            <h3 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-3693">
              Carica fattura
            </h3>
            <p className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3694">
              Il sistema analizzerà la fattura e riporterà le righe con extra
              costi contestabili.
            </p>
          </div>
          <button onClick={onCancel} className="p-1 rounded text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#181818] transition" data-id="element-3695">
            <X className="h-4 w-4" data-id="element-3696" />
          </button>
        </div>
        <div className="p-5 space-y-4" data-id="element-3697">
          <div data-id="element-3698">
            <label className="block text-[10px] uppercase tracking-wider text-[#9A9A9A] font-medium mb-1.5" data-id="element-3699">
              Corriere <span className="text-[#D4FF3A]" data-id="element-3700">*</span>
            </label>
            <select value={carrier} onChange={e => setCarrier(e.target.value)} className="w-full bg-[#181818] border border-[#262626] rounded-lg px-3 py-2 text-sm text-[#FAFAFA] focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-3701">
              <option data-id="element-3702">BRT</option>
              <option data-id="element-3703">GLS</option>
              <option data-id="element-3704">FedEx</option>
              <option data-id="element-3705">UPS</option>
              <option data-id="element-3706">SDA</option>
            </select>
          </div>
          <div data-id="element-3707">
            <label className="block text-[10px] uppercase tracking-wider text-[#9A9A9A] font-medium mb-1.5" data-id="element-3708">
              File fattura <span className="text-[#D4FF3A]" data-id="element-3709">*</span>
            </label>
            <label className={`block w-full p-5 rounded-lg border-2 border-dashed cursor-pointer transition text-center ${file ? 'border-[#D4FF3A]/40 bg-[#D4FF3A]/5' : 'border-[#262626] bg-[#181818] hover:border-[#333]'}`} data-id="element-3710">
              <input type="file" className="sr-only" accept=".pdf,.csv,.xlsx,.xls" onChange={e => setFile(e.target.files?.[0] ?? null)} data-id="element-3711" />
              {file ? <div className="flex items-center justify-center gap-2 text-sm text-[#D4FF3A]" data-id="element-3712">
                  <FileText className="h-4 w-4" data-id="element-3713" />
                  <span className="truncate" data-id="element-3714">{file.name}</span>
                  <span className="text-xs text-[#6B6B6B]" data-id="element-3715">
                    {(file.size / 1024 / 1024).toFixed(1)} MB
                  </span>
                </div> : <>
                  <Upload className="h-6 w-6 text-[#6B6B6B] mx-auto mb-1.5" data-id="element-3716" />
                  <div className="text-xs text-[#9A9A9A]" data-id="element-3717">
                    Clicca per caricare la fattura
                  </div>
                  <div className="text-[10px] text-[#6B6B6B] mt-0.5" data-id="element-3718">
                    PDF, CSV o Excel
                  </div>
                </>}
            </label>
          </div>
        </div>
        <div className="border-t border-[#262626] px-5 py-3 flex items-center justify-end gap-2" data-id="element-3719">
          <button onClick={onCancel} className="px-3.5 py-2 rounded-lg bg-[#181818] border border-[#262626] text-[#FAFAFA] text-sm font-medium hover:border-[#333] transition" data-id="element-3720">
            Annulla
          </button>
          <button onClick={() => file && onSubmit(file, carrier)} disabled={!file} className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold transition ${file ? 'bg-[#D4FF3A] text-[#0A0A0A] hover:bg-[#c2ed28]' : 'bg-[#1F1F1F] text-[#6B6B6B] cursor-not-allowed'}`} data-id="element-3721">
            <Upload className="h-4 w-4" data-id="element-3722" />
            Carica e analizza
          </button>
        </div>
      </div>
    </div>;
}
function VerificaFattureDetail({
  invoice,
  onBack,
  onRequestCredit,
  toast
}: {
  invoice: Invoice;
  onBack: () => void;
  onRequestCredit: () => void;
  toast: string | null;
}) {
  const [query, setQuery] = useState('');
  const [confirmCredit, setConfirmCredit] = useState(false);
  const extraPct = invoice.totalePagato > 0 ? invoice.totaleContestato / invoice.totalePagato * 100 : 0;
  const filteredRows = useMemo(() => invoice.rows.filter(r => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return `${r.numero_sped} ${r.ragione_sociale_destinat} ${r.localita_destinatario} ${r.provincia_destinatario}`.toLowerCase().includes(q);
  }), [invoice.rows, query]);
  const handleExportExcel = () => {
    const header = ['Anno', 'N. spedizione', 'Data ritiro', 'Mittente', 'Destinatario', 'Indirizzo', 'CAP', 'Località', 'Prov.', 'Colli', 'Peso (kg)', 'Natura merce', 'Porto', 'Totale servizi', 'Porto contestabile', 'Servizi contestabili', 'Totale contestato'];
    const rows = invoice.rows.map(r => [String(r.anno_sped), String(r.numero_sped), r.data_ritiro, r.ragione_sociale_mittente, r.ragione_sociale_destinat, r.indirizzo_destinatario, r.cap_destinatario, r.localita_destinatario, r.provincia_destinatario, String(r.numero_colli), r.peso_bollettato_kg.toFixed(2).replace('.', ','), r.natura_merce, r.porto.toFixed(2).replace('.', ','), r.totale_servizi.toFixed(4).replace('.', ','), r.porto_contestabile.toFixed(4).replace('.', ','), r.servizi_contestabili.toFixed(4).replace('.', ','), (r.porto_contestabile + r.servizi_contestabili).toFixed(4).replace('.', ',')]);
    const csv = [header, ...rows].map(row => row.map(cell => `"${cell.replace(/"/g, '""')}"`).join(';')).join('\n');
    const blob = new Blob(['\uFEFF' + csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `analisi_fattura_${invoice.numeroFattura}_${invoice.dataFattura}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <div className="space-y-6" data-id="element-3723">
      <button type="button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-[#9A9A9A] hover:text-[#FAFAFA] transition-colors" data-id="element-3724">
        <ArrowLeft className="h-4 w-4" data-id="element-3725" />
        <span data-id="element-3726">Torna a Verifica Fatture</span>
      </button>

      {/* Header */}
      <div className="bg-[#181818] border border-[#262626] rounded-xl p-4 sm:p-5" data-id="element-3727">
        <div className="flex items-start justify-between gap-4 flex-wrap" data-id="element-3728">
          <div className="flex items-start gap-4" data-id="element-3729">
            <div className="h-12 w-12 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-3730">
              <Receipt className="h-5 w-5 text-[#D4FF3A]" data-id="element-3731" />
            </div>
            <div data-id="element-3732">
              <div className="flex items-center gap-2 mb-1" data-id="element-3733">
                <FileText className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-3734" />
                <span className="text-xs text-[#9A9A9A] truncate max-w-[260px]" data-id="element-3735">
                  {invoice.fileName}
                </span>
              </div>
              <div className="text-xl font-semibold text-[#FAFAFA] font-heading font-mono" data-id="element-3736">
                Fattura {invoice.numeroFattura}
              </div>
              <div className="text-sm text-[#9A9A9A] mt-0.5" data-id="element-3737">
                {invoice.carrier} · {invoice.dataFattura}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap" data-id="element-3738">
            <button type="button" onClick={handleExportExcel} className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#181818] border border-[#262626] text-[#FAFAFA] text-sm font-medium hover:border-[#333] transition" data-id="element-3739">
              <Download className="h-4 w-4" data-id="element-3740" />
              Scarica Excel
            </button>
            {invoice.creditRequested && <span className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 text-[#D4FF3A] text-sm font-semibold" data-id="element-3741">
                <CheckCircle2 className="h-4 w-4" data-id="element-3742" />
                Credito richiesto
              </span>}
          </div>
        </div>
      </div>

      {toast && <div className="flex items-start gap-2 p-3 bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 rounded-lg" data-id="element-3743">
          <CheckCircle2 className="h-4 w-4 text-[#D4FF3A] shrink-0 mt-0.5" data-id="element-3744" />
          <p className="text-sm text-[#FAFAFA]" data-id="element-3745">{toast}</p>
        </div>}

      {/* KPIs */}
      <section className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-3746">
        <KpiCard label="Costo totale" value={`€ ${invoice.totalePagato.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`} data-id="element-3747" />
        <KpiCard label="€ Recuperabile" value={`€ ${invoice.totaleContestato.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`} data-id="element-3748" />
        <KpiCard label="% righe contestate" value={`${(invoice.righeContestate / invoice.righeTotali * 100).toFixed(2)}%`} data-id="element-3749" />
      </section>

      {/* Contested rows table */}
      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3750">
        <div className="p-4 sm:p-5 flex items-center gap-3 flex-wrap border-b border-[#1F1F1F]" data-id="element-3751">
          <div data-id="element-3752">
            <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-3753">
              Righe contestate
            </h3>
            <p className="text-[11px] text-[#6B6B6B] mt-0.5" data-id="element-3754">
              {invoice.rows.length} di{' '}
              {invoice.righeContestate.toLocaleString('it-IT')} righe mostrate.
              Scarica l'Excel per l'analisi completa.
            </p>
          </div>
          <div className="relative ml-auto w-full sm:w-auto" data-id="element-3755">
            <Search className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-3756" />
            <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Cerca n. spedizione, destinatario, città..." className="w-full sm:w-80 pl-9 pr-3 py-2 bg-[#0A0A0A] border border-[#262626] rounded-lg text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-3757" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-3758">
          <table className="w-full text-sm [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap" data-id="element-3759">
            <thead data-id="element-3760">
              <tr className="text-left text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#1F1F1F]" data-id="element-3761">
                <th className="px-5 py-3 font-medium" data-id="element-3762">N. spedizione</th>
                <th className="px-5 py-3 font-medium" data-id="element-3763">Data ritiro</th>
                <th className="px-5 py-3 font-medium" data-id="element-3764">Destinatario</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3765">Colli</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3766">Peso</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3767">Porto</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3768">Servizi</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3769">
                  Porto cont.
                </th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3770">
                  Servizi cont.
                </th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3771">
                  Totale extra
                </th>
              </tr>
            </thead>
            <tbody data-id="element-3772">
              {filteredRows.map(r => {
              const totale = r.porto_contestabile + r.servizi_contestabili;
              return <tr key={r.numero_sped} className="border-b border-[#1F1F1F] last:border-0 hover:bg-[#0A0A0A] transition-colors" data-id="element-3773">
                    <td className="px-5 py-3 font-mono text-xs text-[#FAFAFA]" data-id="element-3774">
                      {r.numero_sped}
                    </td>
                    <td className="px-5 py-3 font-mono text-xs text-[#9A9A9A]" data-id="element-3775">
                      {r.data_ritiro}
                    </td>
                    <td className="px-5 py-3" data-id="element-3776">
                      <div className="text-sm text-[#FAFAFA] truncate max-w-[200px]" data-id="element-3777">
                        {r.ragione_sociale_destinat}
                      </div>
                      <div className="text-[11px] text-[#6B6B6B] truncate max-w-[200px]" data-id="element-3778">
                        {r.cap_destinatario} {r.localita_destinatario} (
                        {r.provincia_destinatario})
                      </div>
                    </td>
                    <td className="px-5 py-3 text-right font-mono text-xs text-[#FAFAFA]" data-id="element-3779">
                      {r.numero_colli}
                    </td>
                    <td className="px-5 py-3 text-right font-mono text-xs text-[#FAFAFA]" data-id="element-3780">
                      {r.peso_bollettato_kg.toFixed(2)} kg
                    </td>
                    <td className="px-5 py-3 text-right font-mono text-xs text-[#FAFAFA]" data-id="element-3781">
                      € {r.porto.toFixed(2)}
                    </td>
                    <td className="px-5 py-3 text-right font-mono text-xs text-[#FAFAFA]" data-id="element-3782">
                      € {r.totale_servizi.toFixed(4)}
                    </td>
                    <td className="px-5 py-3 text-right font-mono text-xs text-[#F5A524]" data-id="element-3783">
                      € {r.porto_contestabile.toFixed(4)}
                    </td>
                    <td className="px-5 py-3 text-right font-mono text-xs text-[#F5A524]" data-id="element-3784">
                      € {r.servizi_contestabili.toFixed(4)}
                    </td>
                    <td className="px-5 py-3 text-right font-mono text-xs font-semibold text-[#F5A524]" data-id="element-3785">
                      € {totale.toFixed(4)}
                    </td>
                  </tr>;
            })}
            </tbody>
            <tfoot className="bg-[#0A0A0A]" data-id="element-3786">
              <tr data-id="element-3787">
                <td colSpan={7} className="px-5 py-3 text-xs uppercase tracking-wider text-[#9A9A9A] font-medium text-right" data-id="element-3788">
                  Totale fattura
                </td>
                <td className="px-5 py-3 text-right font-mono text-sm font-semibold text-[#F5A524]" data-id="element-3789">
                  € {invoice.totalePortoContestabile.toFixed(2)}
                </td>
                <td className="px-5 py-3 text-right font-mono text-sm font-semibold text-[#F5A524]" data-id="element-3790">
                  € {invoice.totaleServiziContestabili.toFixed(2)}
                </td>
                <td className="px-5 py-3 text-right font-mono text-sm font-semibold text-[#F5A524]" data-id="element-3791">
                  € {invoice.totaleContestato.toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {confirmCredit && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-3792">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setConfirmCredit(false)} data-id="element-3793" />
          <div className="relative w-full max-w-md bg-[#0A0A0A] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3794">
            <div className="p-5" data-id="element-3795">
              <div className="flex items-start gap-3" data-id="element-3796">
                <div className="h-10 w-10 rounded-lg bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 flex items-center justify-center shrink-0" data-id="element-3797">
                  <Send className="h-4 w-4 text-[#D4FF3A]" data-id="element-3798" />
                </div>
                <div data-id="element-3799">
                  <h3 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-3800">
                    Richiedi credito al corriere
                  </h3>
                  <p className="text-sm text-[#9A9A9A] mt-1" data-id="element-3801">
                    Stai per richiedere un credito di{' '}
                    <span className="font-semibold text-[#F5A524]" data-id="element-3802">
                      € {invoice.totaleContestato.toFixed(2)}
                    </span>{' '}
                    a {invoice.carrier} per la fattura {invoice.numeroFattura}.
                    Allegheremo l'analisi delle{' '}
                    {invoice.righeContestate.toLocaleString('it-IT')} righe
                    contestate.
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-[#262626] px-5 py-3 flex items-center justify-end gap-2" data-id="element-3803">
              <button onClick={() => setConfirmCredit(false)} className="px-3.5 py-2 rounded-lg bg-[#181818] border border-[#262626] text-[#FAFAFA] text-sm font-medium hover:border-[#333] transition" data-id="element-3804">
                Annulla
              </button>
              <button onClick={() => {
            onRequestCredit();
            setConfirmCredit(false);
          }} className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-3805">
                <Send className="h-4 w-4" data-id="element-3806" />
                Invia richiesta
              </button>
            </div>
          </div>
        </div>}
    </div>;
}
function SplitTile({
  label,
  value,
  color,
  dot,
  highlight
}: {
  label: string;
  value: string;
  color: string;
  dot: string;
  highlight?: boolean;
}) {
  return <div className={`p-3 rounded-lg border ${highlight ? 'bg-[#F5A524]/5 border-[#F5A524]/30' : 'bg-[#0A0A0A] border-[#262626]'}`} data-id="element-3807">
      <div className="flex items-center gap-1.5 mb-1.5" data-id="element-3808">
        <span className={`h-1.5 w-1.5 rounded-full ${dot}`} data-id="element-3809" />
        <span className="text-[10px] uppercase tracking-wider text-[#9A9A9A] font-medium" data-id="element-3810">
          {label}
        </span>
      </div>
      <div className={`text-base font-semibold font-mono ${color}`} data-id="element-3811">
        {value}
      </div>
    </div>;
}